

export default {

    async SET_TOTAL_PARTS_ORDER(state, totalPartsOrders) {
        state.totalPartsOrders = totalPartsOrders
    },
    async ADD_NEW_PARTS_ORDER(state, order) {
        state.partsOrders.splice(0, 0, order) 
    },
    async SET_PARTS_ORDER(state, partsOrders) {
        state.partsOrders = partsOrders
    },
    async UPDATE_PARTS_ORDER(state, order) {
        const partsOrderIndex = state.partsOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.partsOrders[partsOrderIndex], order)
    },

    REMOVE_PARTS_ORDER(state, idOrder) {
        const partsOrderIndex = state.partsOrders.findIndex((p) => p.idOrder == idOrder)
        state.partsOrders.splice(partsOrderIndex, 1)

    },
    
    async SET_PARTS_ORDER_FILTERED(state, partsOrders) {
        state.partsOrdersFiltered = partsOrders
    },

    REMOVE_PARTS_ORDER_FILTERED(state, idOrder) {
        const partsOrderIndex = state.partsOrdersFiltered.findIndex((s) => s.idOrder == idOrder)
        state.partsOrdersFiltered.splice(partsOrderIndex, 1)
    },


}
 